import { MosError } from './MosError';

const AUTHORIZATION_FAILURE_STATUS_CODES = new Set([401, 403]);

export function isAuthorizationFailure(error: unknown): error is MosError {
  return (
    error instanceof MosError &&
    AUTHORIZATION_FAILURE_STATUS_CODES.has(error.statusCode)
  );
}
